/**
 * @generated SignedSource<<48e939d14b2346bef43b8368e47b690f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PageSectionSidebarEventsList_pageSection",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ParticipativeModule",
      "kind": "LinkedField",
      "name": "events",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SidebarEventCard_participativeModule"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MapSidebarEventsList_eventsList"
    }
  ],
  "type": "PageSectionSidebarEventsList",
  "abstractKey": null
};
})();

node.hash = "da0ba256490548b6f5d834543024d1e0";

module.exports = node;
